export const COOKIE_KEY = "supplier-auth";
